import 'babel-polyfill';
import React from 'react';
import ApolloClient, {createNetworkInterface} from 'apollo-client';
import {ApolloProvider} from 'react-apollo';
import config from './config';
import Navigation from './Navigation';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Theme from './theme.js';
import moment from 'moment';
import {AUTH_TOKEN_STORAGE_KEY} from './constants/storageConstants';
import injectTapEventPlugin from 'react-tap-event-plugin';

moment.locale('de');

injectTapEventPlugin();
const networkInterface = createNetworkInterface({
  uri: config.apiUrl + '/graphql',
});

const logErrors = {
  applyAfterware({response}, next) {
    if (!response.ok) {
      response
        .clone()
        .text()
        .then(bodyText => {
          if (bodyText.includes('TokenInvalidError') || bodyText.includes('TokenExpiredError')) {
            localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
            window.location.reload();
          } else {
            console.log(bodyText);
            next();
          }
        });
    } else {
      response
        .clone()
        .json()
        .then(({errors}) => {
          if (errors) {
            for (let {name} of errors) {
              if (name === 'TokenInvalidError' || name === 'TokenExpiredError') {
                localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
                window.location.reload();
              }
            }
            next();
          } else {
            next();
          }
        });
    }
  },
};
networkInterface.use([
  {
    applyMiddleware(req, next) {
      if (!req.options.headers) {
        req.options.headers = {}; // Create the header object if needed.
      }
      req.options.headers.authorization = config.getAuthHeader();
      next();
    },
  },
]);

networkInterface.useAfter([logErrors]);

const client = new ApolloClient({networkInterface});

export default () => (
  <MuiThemeProvider muiTheme={Theme}>
    <ApolloProvider client={client}>
      <Navigation />
    </ApolloProvider>
  </MuiThemeProvider>
);



// WEBPACK FOOTER //
// ./src/App.js